module.exports = __webpack_public_path__ + "img/avatar.6992653d.svg";